<template>
  <div class="p-menus-no-detail-infomation">
    <div v-for="item in infoData" :key="item.id">
      <p v-if="item.title" class="p-menus-no-detail-infomation__header">
        {{ item.title }}
      </p>
      <div
        v-if="item.content || item.linkUrl"
        class="p-menus-no-detail-infomation__body"
      >
        <p v-if="item.content">{{ item.content }}</p>
        <a
          v-if="item.linkUrl"
          :href="item.linkUrl"
          class="p-menus-no-detail-infomation__link"
          target="_blank"
        >
          {{ item.linkNm }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    menuNo: {
      required: true
    },
    menu: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isShowInfomation: false,
      openHeight: 0,
      isShowToggle: true
    };
  },
  computed: {
    infoData() {
      if (this.menu.menuInfomation) {
        return this.menu.menuInfomation;
      } else if (this.menu.planInfomation) {
        return this.menu.planInfomation;
      }
      return []
    }
  },
};
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
